import { endOfDay, isValid, parseISO } from 'date-fns';

/**
 * Safely parse a JSON string. Returns null instead of throwing when the input
 * is empty/null or cannot be parsed (e.g. corrupt localStorage).
 * @param value The JSON string to parse
 * @param context Optional label used in the error log to aid debugging
 */
export function safeJsonParse<T>(value: string | null | undefined): T | null {
  if (!value) return null;

  try {
    return JSON.parse(value) as T;
  } catch (e) {
    console.error('Problem parsing JSON', e);
    return null;
  }
}

/**
 * The period is stored as `yyyy-MM-dd`, which the export API rejects: it wants
 * a full ISO datetime. `to` is stretched to the end of the day so the last day
 * of the selected period is included.
 */
export const toIsoDateTime = (
  value: string | undefined,
  bound: 'start' | 'end'
) => {
  if (!value) {
    return undefined;
  }

  const date = parseISO(value);

  if (!isValid(date)) {
    return undefined;
  }

  return (bound === 'end' ? endOfDay(date) : date).toISOString();
};
